import type { ShapeCommittedUndoMeta } from '@/lib/shapes/types/shape-committed-undo-meta'
import type { ShapeData } from '@/lib/shapes/types/shape-data'

export function buildUnifiedSelectionSingleShapeResizeUndo(params: {
  before: Pick<ShapeData, 'x' | 'y' | 'width' | 'height'> & {
    path?: ShapeData['path']
    pathCommands?: ShapeData['pathCommands']
  }
  after: Pick<ShapeData, 'x' | 'y' | 'width' | 'height'> & {
    path?: ShapeData['path']
    pathCommands?: ShapeData['pathCommands']
  }
  mode?: 'any' | 'width' | 'height'
  includePathWhenPresent?: boolean
  positionEpsilon?: number
  sizeEpsilon?: number
}): ShapeCommittedUndoMeta | undefined {
  const {
    before,
    after,
    mode = 'any',
    includePathWhenPresent = false,
    positionEpsilon = 1e-4,
    sizeEpsilon = 1e-4,
  } = params
  const xDiff = Math.abs(before.x - after.x) > positionEpsilon
  const yDiff = Math.abs(before.y - after.y) > positionEpsilon
  const wDiff = Math.abs(before.width - after.width) > sizeEpsilon
  const hDiff = Math.abs(before.height - after.height) > sizeEpsilon
  const changed =
    mode === 'width'
      ? xDiff || yDiff || wDiff
      : mode === 'height'
        ? xDiff || yDiff || hDiff
        : xDiff || yDiff || wDiff || hDiff

  if (!changed) return undefined

  const undoBefore: Partial<ShapeData> = {
    x: before.x,
    y: before.y,
    width: before.width,
    height: before.height,
  }
  const undoAfter: Partial<ShapeData> = {
    x: after.x,
    y: after.y,
    width: after.width,
    height: after.height,
  }

  if (
    includePathWhenPresent &&
    Array.isArray(before.pathCommands) &&
    before.pathCommands.length > 0
  ) {
    undoBefore.path = before.path
    undoBefore.pathCommands = before.pathCommands
    undoAfter.path = after.path
    undoAfter.pathCommands = after.pathCommands
  }

  return { before: undoBefore, after: undoAfter }
}
